import { render, staticRenderFns } from "./SamplePage.vue?vue&type=template&id=c53828ee&"
import script from "./SamplePage.vue?vue&type=script&lang=js&"
export * from "./SamplePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports